import api, { checkTokenErrorResponse } from '..';

const tipos_documento=[
    //[0, 'Nota Fiscal de Entrada'],
    [1, 'Nota Fiscal de Saída']
]
const locais_destino = [
    [1, 'Operação Interna'],
    [2, 'Operação Interestadual'],
    [3, 'Operação com Exterior'],
]
const finalidades_emissao = [
    [1, 'Normal'],
    //[2, 'Complementar'],
    //[3, 'Nota de Ajuste'],
    [4, 'Devolução'],
]
const consumidores_finais = [
    [0, 'Normal'],
    [1, 'Consumidor Final'],
]

const tipos_presenca_comprador = [
    [0, 'Não se aplica'],
    [1, 'Operação presencial'],
    [2, 'Operação não presencial, pela Internet'],
    [3, 'Operação não presencial, Teleatendimento'],
    [4, 'NFC-e em operação com entrega em domicílio'],
    [9, 'Operação não presencial, outros'],
]

const tipos_modalidade_frete = [
    [0, "Por conta do emitente"],
    [1, "Por conta do destinatário"],
    [2, "Por conta de terceiros"],
    [9, "Sem frete"],
]

export async function getNfeBill(id) {
    return api.get(`contas/${id}/nfe/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function deleteNfeBill(id) {
    return api.delete(`contas/${id}/nfe/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function postNfeBill(
    id,
    natureza_operacao,
    data_emissao,
    tipo_documento,
    local_destino,
    finalidade_emissao,
    consumidor_final,
    presenca_comprador,
    modalidade_frete,
    valor_frete,
    valor_desconto,
    valor_seguro
    ) {
    const data = {
        natureza_operacao,
        data_emissao,
        tipo_documento,
        local_destino,
        finalidade_emissao,
        consumidor_final,
        presenca_comprador,
        modalidade_frete,
        valor_frete,
        valor_desconto,
        valor_seguro,
    }

    return api.post(`contas/${id}/nfe/`, data)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};


const nfeServices = {
    getNfeBill,
    deleteNfeBill,
    postNfeBill,
    tipos_documento,
    tipos_modalidade_frete,
    tipos_presenca_comprador,
    locais_destino,
    finalidades_emissao,
    consumidores_finais,
}
export default nfeServices;